import { render, staticRenderFns } from "./CreateChartOfAccount.vue?vue&type=template&id=3459d574"
import script from "./CreateChartOfAccount.vue?vue&type=script&lang=js"
export * from "./CreateChartOfAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports